export default __webpack_public_path__ + "static/media/Product-versions.1d7a6f51.svg";